
export const petImages = {
  hungry: require('@/assets/pets/hungry.png'),
  sad: require('@/assets/pets/sad.png'),
  dirty: require('@/assets/pets/dirty.png'),
  happy: require('@/assets/pets/happy.png')
}